<template>
  <div v-if="isVisible" class="hp_popupBg" @click="handleOutsideClick">
    <div class="hp_popupContentWrap" @click.stop>
      <button @click="closePopup">Close</button>
        <div class="hp_popupContentBox" v-if="toggleStatus === 1">
          <h2>수집하는 개인정보의 항목</h2>
          <div class="hp_popupContentInto">
            <span class="hp_pageTerms_boldTxt">수집하는 개인정보의 항목 및 수집방법</span><br/>
            <p class="hp_pageTerms_txt">
              (주)행복을주는사람들은 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[회원가입]</span>
              <p class="hp_pageTerms_txt">
                ◦ 필수항목 : 아이디, 비밀번호, 이름, E-Mail, 전화번호, 휴대폰번호, SMS 수신여부<br/>
                ◦ 선택항목 : 주소
              </p>
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[아이디/비밀번호찾기]</span>
              <p class="hp_pageTerms_txt">
                ◦ 필수항목 : 이름, 아이디, 휴대폰번호<br/>
                ◦ 선택항목 : 없음
              </p>
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[여행예약하기]</span>
              <p class="hp_pageTerms_txt">
                ◦ 필수항목 : 예약자명, 핸드폰번호, 전화번호, 실제여행자정보 (성명, 전화번호,생년월일), 무통장 입금 (입금자명)<br/>
                ◦ 선택항목 : E-Mail, 실제여행자정보 (비고), 남기실말씀
              </p>
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[게시판 - 글쓰기]</span>
              <p class="hp_pageTerms_txt">
                ◦ 필수항목 : 작성자, 비밀번호<br/>
                ◦ 선택항목 : E-Mail
              </p>
            </div>
            <div class="hp_pageTerms_grayBoxSub">
              <span class="hp_pageTerms_pointTxt">[예약/결제현황]</span>
              <p class="hp_pageTerms_txt">
                ◦ 필수항목 : 예약자명, 휴대폰번호<br/>
                ◦ 선택항목 : 없음
              </p>
            </div>
          </div>
        </div>
        <div class="hp_popupContentBox" v-if="toggleStatus === 2">
          <h2>개인 정보의 수집 이용목적</h2>
          <div class="hp_popupContentInto">
            <span class="hp_pageTerms_boldTxt">개인정보의 수집 및 이용목적</span><br/>
            <p class="hp_pageTerms_txt">
              (주)행복을주는사람들는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              ◦ 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산<br/>
              ◦ 콘텐츠 제공, 구매 및 요금 결제, 금융거래 본인 인증 및 금융 서비스<br/>
              ◦ 회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 불만처리 등 민원처리, 고지사항 전달
            </div>
          </div>
        </div>
        <div class="hp_popupContentBox" v-if="toggleStatus === 3">
          <h2>개인정보의 보유 및 이용기간</h2>
          <div class="hp_popupContentInto">
            <span class="hp_pageTerms_boldTxt">개인정보의 보유 및 이용기간</span><br/>
            <p class="hp_pageTerms_txt">
              원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.<br/>
              단, 상법 및 '전자상거래등에서 소비자보호에 관한 법률' 등 관련 법령의 규정에 의하여 다음과 같이 거래 관련 관리 의무 관계의 확인 등을 이유로 일정기간 보유하여야 할 필요가 있을 경우에는 일정기간 보유합니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
            ◦ 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년<br/>
            ◦ 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년<br/>
            ◦ 대금결제 및 재화 등의 공급에 관한 기록 : 5년<br/>
            ◦ 계약 또는 청약철회 등에 관한 기록 : 5년<br/>
            ◦ 표시/광고에 관한 기록 : 6개월<br/>
            ◦ 설문조사, 이벤트 등 일시적 목적을 위하여 수집한 경우 : 당해 설문조사, 이벤트 등의 종료 시점
            </div>
          </div>
        </div>
        <div class="hp_popupContentBox" v-if="toggleStatus === 4">
          <h2>서비스 이용약관</h2>
          <div class="hp_popupContentInto">
            <div class="hp_pageTerms_grayBoxMain">
              (주)행복을주는사람들은 공정거래위원회에서 심의한 표준약관 (공정거래위원회 표준약관 제10023호)을 사용하고 있습니다.
            </div>
            <h4>[제1조] 목적</h4>
            <p class="hp_pageTerms_txt">
              본 약관은 (주)행복을주는사람들 (이하 "회사")가 제공하는 모든 서비스의 이용조건 및 절차에 관한 사항과 기타 필요한 사항을 전기통신사업법 및 동법 시행령이 정하는 대로 준수하고 규정함을 목적으로 합니다.
            </p>
            <h4>[제2조] 약관의 효력과 변경</h4>
            <p class="hp_pageTerms_txt">
              1. 이 약관은 이용자에게 공시함으로써 효력을 발생합니다.<br />
              2. 회사는 사정 변경의 경우와 영업상 중요 사유가 있을 때 약관을 변경할 수 있으며, 변경된 약관은 전항과 같은 방법으로 효력을 발생합니다.
            </p>
            <h4>[제3조] 약관 외 준칙</h4>
            <p class="hp_pageTerms_txt">
              이 약관에 명시되지 않은 사항이 관계 법령에 규정되어 있을 경우에는 그 규정에 따릅니다.
            </p>
            <h4>[제4조] 서비스 이용 계약의 성립</h4>
            <p class="hp_pageTerms_txt">
              1. 이용 계약은 이용자의 회원등록 신청에 대한 회사의 이용 승낙과 이용자의 약관 내용에 대한 동의로 성립됩니다.<br />
              2. 회원에 가입하여 서비스를 이용하고자 하는 희망자는 회사에서 요청하는 개인 신상정보를 제공해야 합니다.<br />
              3. 이용자의 이용신청에 대하여 회사가 이를 승낙한 경우, 회사는 회원 ID와 기타 회사가 필요하다고 인정하는 내용을 이용자에게 통지합니다.<br />
              4. 회사는 다음 각 호에 해당하는 이용계약 신청에 대하여는 이를 승낙하지 아니 합니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 다른 사람의 명의를 사용하여 신청하였을 때<br />
              나. 본인의 실명으로 신청하지 않았을 때<br />
              다. 이용 계약 신청서의 내용을 허위로 기재하였을 때<br />
              라. 사회의 안녕과 질서 혹은 미풍양속을 저해할 목적으로 신청하였을 때
            </div>
            <h4>[제5조] 회원가입</h4>
            <p class="hp_pageTerms_txt">
              1. 이용자는 회사가 정한 가입양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.<br />
              2. 이용자는 반드시 실명으로 회원가입을 하여야 하며, 1개의 이름에 대해 1건의 회원가입 신청을 할 수 있습니다.<br />
              3. 회원가입계약의 성립시기는 회사의 승낙이 이용자에게 도달한 시점으로 합니다.<br />
              4. 회원은 등록사항에 변경이 있는 경우 회원정보변경 항목을 통해 직접 변경사항을 수정, 등록하여야 합니다.<br />
              5. 회사는 제 1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 이름이 실명이 아닌 경우<br />
              나. 등록 내용에 허위, 기재누락, 오기가 있는 경우<br />
              다. 타인의 명의를 사용하여 신청한 경우<br />
              라. 가입신청자가 이 약관 제 8조 3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우 (단, 회원자격 상실 후 3년이 경과한 자로서 회사의 회원 재가입 승낙을 얻은 경우는 예외로 합니다.)<br />
              마. 만 14세 미만의 아동<br />
              바. 기타 회원으로 회사 소정의 이용신청요건을 충족하지 못하는 경우
            </div>
            <h4>[제6조] 회원탈퇴 및 자격 상실 등</h4>
            <p class="hp_pageTerms_txt">
              1. 회원은 언제든지 회원의 탈퇴를 홈페이지에 요청할 수 있으며, 홈페이지는 즉시 이에 응합니다.<br />
              2. 회사가 회원자격을 제한/정지시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 회사는 회원자격을 상실 시킬 수 있습니다.<br />
              3. 회사가 회원자격을 상실 시키는 경우 회원에게 이를 통지하고 탈퇴를 처리합니다. 이 경우 회원에게 이를 통지하고, 탈퇴 전에 소명할 기회를 부여합니다.<br />
              4. 회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원자격을 제한 및 정지시킬 수 있습니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 가입 신청 시에 허위 내용을 등록한 경우<br />
              나. 타인의 서비스 이용을 방해하거나 그 정보를 도용하는 등 서비스 운영질서를 위협하는 경우<br />
              다. 서비스를 이용하여 법령과 이 약관이 금지하거나, 공서양속에 반하는 행위를 하는 경우<br />
              라. 제 13조 에 명기된 회원의 의무사항을 준수하지 못할 경우
            </div>
            <h4>[제7조] 이용자에 대한 통지</h4>
            <p class="hp_pageTerms_txt">
              1. 회사가 이용자에 대한 통지를 하는 경우, 이용자가 서비스에 제출한 전자우편 주소로 할 수 있습니다.<br />
              2. 회사가 불특정 다수 이용자에 대한 통지의 경우 1주일 이상 서비스 게시판에 게시함으로써 개별 통지에 갈음할 수 있습니다.
            </p>
            <h4>[제8조] 회사의 의무</h4>
            <p class="hp_pageTerms_txt">
              1. 회사는 특별한 사정이 없는 한 회원이 신청한 서비스 제공 개시일에 서비스를 이용할 수 있도록 합니다.<br />
              2. 회사는 이 약관에서 정한 바에 따라 계속적, 안정적으로 서비스를 제공할 의무가 있습니다.<br />
              3. 회사는 회원으로부터 소정의 절차에 의해 제기되는 의견에 대해서는 적절한 절차를 거쳐 처리하며, 처리시 일정 기간이 소요될 경우 회원에게 그 사유와 처리 일정을 알려주어야 합니다.<br />
              4. 회사는 회원의 정보를 철저히 보안 유지하며, 양질의 서비스를 운영하거나 개선하는 데에만 사용하고, 이외의 다른 목적으로 타 기관 및 개인에게 양도하지 않습니다.
            </p>
            <h4>[제9조] 회원의 ID 및 비밀번호에 대한 의무</h4>
            <p class="hp_pageTerms_txt">
              1. 회원에게 부여된 아이디(ID)와 비밀번호의 관리책임은 회원에게 있으며 관리 소홀, 부정사용에 의하여 발생하는 모든 결과에 대한 책임은 회원에게 있습니다.<br />
              2. 회원이 자신의 ID 및 비밀번호를 도난 당하거나 제 3자가 사용하고 있음을 인지한 경우에는 바로 회사에 통보하고 회사의 안내가 있는 경우에는 그에 따라야 합니다.
            </p>
            <h4>[제10조] 회원의 의무</h4>
            <p class="hp_pageTerms_txt">
              1. ID와 비밀번호에 관한 모든 관리의 책임은 회원에게 있습니다.<br />
              2. 회원은 서비스의 일부로 보내지는 의 전자우편을 받는 것에 동의합니다.<br />
              3. 자신의 ID가 부정하게 사용된 경우, 회원은 반드시 회사에 그 사실을 통보해야 합니다.<br />
              4. 회원은 이 약관 및 관계 법령에서 규정한 사항을 준수하여야 합니다.
            </p>
            <h4>[제11조] 게시물 삭제</h4>
            <p class="hp_pageTerms_txt">
              회원이 게시하거나 등록한 내용물이 다음 사항에 해당된다고 판단되는 경우에 사전 통지 없이 삭제할 수 있습니다.
            </p>
            <div class="hp_pageTerms_grayBoxSub">
              가. 타인을 비방하거나 중상모략으로 개인 및 단체의 명예를 손상시키는 내용인 경우<br />
              나. 공공질서 및 미풍양속에 위반되는 내용인 경우<br />
              다. 범죄적 행위에 부합된다고 인정되는 내용인 경우<br />
              라. 타인의 저작권 등 기타의 권리를 침해하는 내용인 경우<br />
              마. 기타 관계 법령이나 회사에서 정한 규정에 위배되는 내용인 경우
            </div>
            <h4>[제12조] 게시물에 대한 권리 / 의무</h4>
            <p class="hp_pageTerms_txt">
              게시물에 대한 저작권을 포함한 모든 권리 및 책임은 이를 게시한 이용자에게 있습니다.
            </p>
            <h4>[제13조] 손해배상</h4>
            <p class="hp_pageTerms_txt">
              회사는 무료로 제공되는 서비스와 관련하여 이용자에게 어떠한 손해가 발생하더라도 동 손해가 회사의 중대한 과실에 의한 경우를 제외하고 이에 대하여 책임을 부여하지 아니합니다.
            </p>
            <h4>[제14조] 분쟁의 해결</h4>
            <p class="hp_pageTerms_txt">
              1. 회사와 이용자는 서비스와 관련하여 발생한 분쟁을 원만하게 해결하기 위하여 필요한 모든 노력을 하여야 합니다.<br />
              2. 1항의 규정에도 불구하고, 동 분쟁으로 인하여 소송이 제기될 경우 동 소송은 회사의 본사 소재지를 관할하는 법원을 관할법원으로 합니다.<br />
              3. 동 소송에는 대한민국 법을 적용합니다.
            </p>
            <h4>[제15조] 기타</h4>
            <p class="hp_pageTerms_txt">
              이 약관에 명시되지 아니한 사항의 처리를 위하여 이용자는 담당자에게 문의해주시면 됩니다.
            </p>
            <h4>[부칙]</h4>
            <p class="hp_pageTerms_txt">
              이 약관은 2015년 08월 01일부터 시행합니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
export default {
  name: 'PopupComponent',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    toggleStatus: {
      type: Number,
      default: 1
    }
  },
  methods: {
    closePopup () {
      this.$emit('update:isVisible', false)
    },
    handleOutsideClick () {
      this.closePopup()
    },
    handleKeydown (event) {
      if (event.key === 'Escape') {
        this.closePopup()
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeUnmount () {
    window.removeEventListener('keydown', this.handleKeydown)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Section/PopupComponent.vue